(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "affix-placeholder",
        style: _vm.wrapStyle
      }, [_c('div', {
        class: {
          affix: _vm.affixed
        },
        style: _vm.styles
      }, [_vm._t("default")], 2)]);
    },
    name: 'nx-sticky',
    props: {
      offset: {
        type: Number,
        default: 0
      },
      boundary: {
        type: String,
        default: ''
      }
    },
    data: function data() {
      return {
        affixed: false,
        styles: {},
        affixedClientHeight: 0,
        wrapStyle: {}
      };
    },
    methods: {
      getScroll: function getScroll(w, top) {
        var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
        var method = "scroll".concat(top ? 'Top' : 'Left');

        if (typeof ret !== 'number') {
          var d = w.document; // ie6,7,8 standard mode

          ret = d.documentElement[method];

          if (typeof ret !== 'number') {
            // quirks mode
            ret = d.body[method];
          }
        }

        return ret;
      },
      getOffset: function getOffset(element) {
        var rect = element.getBoundingClientRect();
        var body = document.body;
        var clientTop = element.clientTop || body.clientTop || 0;
        var clientLeft = element.clientLeft || body.clientLeft || 0;
        var scrollTop = this.getScroll(window, true);
        var scrollLeft = this.getScroll(window);
        return {
          top: rect.bottom + scrollTop - clientTop - this.affixedClientHeight,
          left: rect.left + scrollLeft - clientLeft
        };
      },
      handleScroll: function handleScroll() {
        var scrollTop = this.getScroll(window, true) + this.offsets; // handle setting offset

        var elementOffset = this.getOffset(this.$el);

        if (!this.affixed && scrollTop > elementOffset.top) {
          this.affixed = true;
          this.styles = {
            top: "".concat(this.offsets, "px"),
            left: "".concat(elementOffset.left, "px"),
            width: "".concat(this.$el.offsetWidth, "px")
          };
        } // if setting boundary


        if (this.boundary && scrollTop > elementOffset.top) {
          var el = document.getElementById(this.boundary);

          if (el) {
            var boundaryOffset = this.getOffset(el);

            if (scrollTop + this.offsets > boundaryOffset.top) {
              var top = scrollTop - boundaryOffset.top;
              this.styles.top = "-".concat(top, "px");
            }
          }
        }

        if (this.affixed && scrollTop < elementOffset.top) {
          this.affixed = false;
          this.styles = {};
        }

        if (this.affixed && this.boundary) {
          var _el = document.getElementById(this.boundary);

          if (_el) {
            var _boundaryOffset = this.getOffset(_el);

            if (scrollTop + this.offsets <= _boundaryOffset.top) {
              this.styles.top = 0;
            }
          }
        }

        this.$emit('onScroll', scrollTop, this.affixed);
      },
      // public method
      reflow: function reflow() {
        var _this = this;

        this.$nextTick(function () {
          _this.affixedClientHeight = _this.$el.children[0].clientHeight;
          _this.wrapStyle = _objectSpread(_objectSpread({}, _this.wrapStyle), {}, {
            height: "".concat(_this.affixedClientHeight, "px")
          });
        });
      }
    },
    computed: {
      offsets: function offsets() {
        if (this.boundary) {
          return 0;
        }

        return this.offset;
      }
    },
    mounted: function mounted() {
      this.reflow();
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
    },
    beforeDestroy: function beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    }
  };
  _exports.default = _default;
});